import { render } from "./FrenKorugu.vue?vue&type=template&id=2956efd2"
import script from "./FrenKorugu.vue?vue&type=script&lang=js"
export * from "./FrenKorugu.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\ulas\\Desktop\\projeler\\eku\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__